const ButtonTextOnly = ({ title, ...rest }) => {
	return <button {...rest}>{title}</button>;
};

export default ButtonTextOnly;
